// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button } from "@revvsales/components";

// Comonents Imports
import { updateDocDetails } from "../../actions/DocumentActions";
import StatusDropdown from "../QuotationTopbar/StatusDropdown";

class DocEditFromSendToSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      documentName: props.docName,
      showButtunLoader: false,
    };
  }

  _toggleLoader = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _onConfirmation = data => {
    const { confirmAction, closePopup } = this.props;
    confirmAction(data);
    closePopup();
  };

  _updateDocDetails = () => {};

  _onClose = () => {
    this.props.onClose("showDocEditFromSendToSignatureModal", false);
  };

  render() {
    const { documentName, showButtunLoader } = this.state;
    const { docID } = this.props;
    return (
      <Modal open onClose={this._onClose} closeOnOverlayClick={false} center>
        <div
          className="quotationtopbar-container"
          data-test="quotationtopbar-container">
          <div className="quotationtopbar-form">
            <div className="quotationtopbar-form-field">
              <div
                className="createdoc-title"
                data-test="doc-sharing-popup-title">
                Are you sure you want to edit {documentName}?
              </div>
            </div>
          </div>
          <div className="doceditfromsendpopup-docstatus-wrapper">
            <div className="doc-status-lable">
              <span>
                Once you edit this document, Shared link will be cancelled,
                Signature requests will be withdrawn
              </span>
            </div>
          </div>
          <div className="docedit-popup-docstatus-wrapper">
            <div className="doc-status-lable">
              <span>Also update document status to</span>
            </div>
            <div className="doc-status-select">
              <StatusDropdown
                currentStatus={this.props.documentStatus}
                docId={this.props.docID}
                currentTag={
                  this.props.documentTag && this.props.documentTag.name
                }
                source="Popup"
              />
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="doc-edit-fromsend-signature-cancel-btn"
              id="doc-edit-fromsend-signature-cancel-btn"
              onClick={() => this._onClose()}>
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              data-test="quotationtopbar-docname-proceed-button"
              isLoading={showButtunLoader}
              onClick={() => this._onConfirmation(docID)}>
              Continue
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  updateDocDetails,
};

export default connect(
  null,
  mapDispatchToProps,
)(DocEditFromSendToSignature);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/DocEditFromSendToSignature.js